import "./index.scss";

import React from "react";
import gridImg from "../../assets/images/bg-grid.png";
import TriangleImg from "../../assets/images/bg-middle2.png";
import logoImg from "../../assets/images/svg/art_icon.svg";
// import ShapesImg from "../../assets/images/bg-middle_shadows.png";
// import ShapePrintsImg from "../../assets/images/bg-middle2.png";
import Figure from "../Figure";

const Mission = () => {
  return (
    <div className={`mission`} id="mission">
      <div className={`mission__container`}>
        {/* <div className={`mission__image-wrapper mission__image-wrapper--top`}>
          <img
            className={`mission__image mission__image--grid`}
            src={gridImg}
            alt="grid"
          />
          <img
            className={`mission__image mission__image--triangle`}
            src={TriangleImg}
            alt="triangle"
          />
        </div>
        <div className={`mission__content--top mission__content`} id="example">
          <Figure classnames={`mission__figure--1st`} />
          <p className={`mission__a1 mission__text--1st mission__text`}>
            The art industry is rapidly veering towards the digital not only in
            order to adjust to the altered world landscape, elevated financial
            strains, and a younger collector demographic, but also to actively
            engage a global audience. Now is the time to rethink the whole
            vision of what galleries represent by drifting away from the
            constrains of physical dimensions in favour of eye-opening digital
            tools for art demonstration and communication.
          </p>
          <p className={`mission__a2 mission__text--2nd mission__text`}>
            An online presence is no longer optional — it’s essential.
          </p>
        </div>
        <div
          className={`mission__image-wrapper mission__image-wrapper--bottom`}
        >
          <img
            className={`mission__image mission__image--grid-bottom`}
            src={gridImg}
            alt="grid"
          />
          <img
            className={`mission__a6 mission__image mission__image--shapes`}
            src={ShapesImg}
            alt="shapes"
            id="mission__a6"
          />
          <img
            className={`mission__image mission__image--prints`}
            src={ShapePrintsImg}
            alt="prints"
          />
        </div> */}
        <div className={`mission__content mission__content--bottom`}>
          <Figure classnames={`mission__figure--2nd`} />
          <img src={logoImg} alt="logo" className={`mission__logo`} />
          <h2 className={`mission__title`}>mission</h2>
          <p
            className={`mission__a2 mission__text mission__text--bottom1`}
            id={`missionTextBottom1`}
          >
            Our mission is to empower the art world through technology.
          </p>
          <p
            className={`mission__a2 mission__text mission__text--2nd mission__text--top2`}
            id={`missionTextBottom2`}
          >
            Maison d’Art is an innovative AI-powered platform, designed to help art professionals and collectors manage, buy and sell artworks.
          </p>
          <p
            className={`mission__a2 mission__text mission__text--2nd mission__text--top2`}
            id={`missionTextBottom2`}
          >
            The platform is an ecosystem of interconnected apps, which work together to revamp the way individuals and businesses in the art market interact with each other. At the centre of this ecosystem is a vast collection of artworks, contributed by galleries, artists and collectors. Maison d’Art helps buyers find their desired artwork. Our AI tools combine traditional search parameters with a visual reference search to automatically identify the best matches on the platform.
          </p>
          <p
            className={`mission__a2 mission__text mission__text--2nd mission__text--top2`}
            id={`missionTextBottom2`}
          >
            Our neural networks continually learn from the growing wealth of data available on the platform to proactively suggest perfect solutions to all clients using the platform.
          </p>
          <p
            className={`mission__a3 mission__text mission__text--2nd mission__text--top2`}
            id={`missionTextBottom2`}
          >
            In your hands, this technology will revolutionise the art selling process.
          </p>
          <p
            className={`mission__a4 mission__text mission__text--2nd mission__text--top2`}
            id={`missionTextBottom2`}
          >
            Currently the Maison d’Art Platform consists of two apps: MA/Gallery and MA/ArtUp. Read on to find out more about each app.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Mission;
